import React from 'react'
import { Typography } from '@mui/material'
import { MainBox } from '../EducatorDashboard/styles'
import { cancellationPolicySx } from './styles'

export const CancellationPolicy = () => {
  return (
    <MainBox sx={cancellationPolicySx.mainBox}>
      <Typography variant="h4" color={"primary"} sx={cancellationPolicySx.title}>Cancellation Policy</Typography>
      <Typography sx={cancellationPolicySx.description}>
        Learners can cancel their enrolled course for a full refund anytime up to and including the first day of class. After the first day of class, no refund will provided.
        <br /> You can reach out to your Educator or to <strong>support@vulcanlearning.com</strong> if you are not satisfied with your course.
      </Typography>
    </MainBox>
  )
}
